"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiIngestVideoStatusesClient = void 0;
const ApiSubClient_1 = require("../../common/client/ApiSubClient");
class ApiIngestVideoStatusesClient extends ApiSubClient_1.ApiSubClient {
    getAll() {
        const statusesLink = this.getLinkOrThrow('ingestVideoStatuses');
        return this.axios.get(statusesLink.href).then((it) => {
            try {
                return it.data._embedded.ingestVideoStatuses;
            }
            catch (e) {
                throw new Error(`Could not unpack ingest video statuses because: ${e}`);
            }
        });
    }
}
exports.ApiIngestVideoStatusesClient = ApiIngestVideoStatusesClient;
//# sourceMappingURL=ApiIngestVideoStatusesClient.js.map